import React from "react"

const Banner = ({ title, light, subtitle, bannerBorder }) => {
    const bannerContent = (
        <>
            <div className='flex  align-center gap-30'>
                <p className='sm-copy text-center'>{title}</p>
                {subtitle && (
                    <>
                        <div className={`dot small ${light ? "dark" : ""}`} role='presentation' />
                        <p>{subtitle}</p>
                    </>
                )}
            </div>
        </>
    )

    return <div className={`banner ${light ? "light" : ""} ${bannerBorder ? "bb1" : ""} flex text-center align-center justify-center`}>{bannerContent}</div>
}

export default Banner
